import { urlSafe, textEncodeLite, BasicQueryStringUtils, LocationLike, bufferToString } from '@openid/appauth';
import { sha256 } from 'js-sha256';

const HAS_CRYPTO = typeof window !== 'undefined' && !!(window.crypto as any);
const HAS_SUBTLE_CRYPTO = HAS_CRYPTO && !!(window.crypto.subtle as any);

export const generateRandom = (size: number): string => {
    const randomValues = new Uint8Array(size);
    if (HAS_CRYPTO) {
        window.crypto.getRandomValues(randomValues);
    } else {
        for (let i = 0; i < size; i++) {
            randomValues[i] = Math.floor(Math.random() * 256);
        }
    }
    return bufferToString(randomValues);
};

export const deriveChallenge = (codeVerifier: string): Promise<string> => {
    if ( !HAS_SUBTLE_CRYPTO ) {
        return new Promise((resolve, reject) => {
            try {
                const hashed = sha256.array(codeVerifier);
                const urlSafeBase64 = urlSafe(new Uint8Array(hashed));
                resolve(urlSafeBase64);
            } catch (error) {
                reject(error);
            }
        });
    } else {
        return new Promise((resolve, reject) => {
            crypto.subtle.digest('SHA-256', textEncodeLite(codeVerifier)).then(buffer => {
              return resolve(urlSafe(new Uint8Array(buffer)));
            }, error => reject(error));
          });
    }
};

export const NoHashQueryStringUtils = Object.assign(Object.create(BasicQueryStringUtils.prototype), {
    parse(input: LocationLike, useHash: boolean): {[key: string]: string; } {
        return BasicQueryStringUtils.prototype.parse.call(this, input, false);
    }
});
